export const PLAN_OPTIONS = [
  { code: "INICIO", name: "Inicio", maxUsers: 3 },
  { code: "PRODUCCION", name: "Produccion", maxUsers: 5 },
  { code: "INTEGRAL", name: "Integral", maxUsers: 15 },
  { code: "PERSONALIZADO", name: "Personalizado", maxUsers: null },
];

export function planCode(user) {
  return String(user?.subscription?.code || "INICIO").toUpperCase();
}

export function hasPlanFeature(user, feature) {
  return user?.subscription?.features?.[feature] !== false;
}

export function planUserLimit(user) {
  const value = user?.subscription?.maxUsers;
  return value == null ? null : Number(value);
}

export function planName(user) {
  return user?.subscription?.name || PLAN_OPTIONS.find((item) => item.code === planCode(user))?.name || "Inicio";
}
